import { useEffect, useState } from "react";

export const useMultiAudio = (audios) => {
  const [sources, setSources] = useState([]);
  const [soundFiles, setSoundFiles] = useState([]);
  const [toggledSound, setToggledSound] = useState({});

  const [soundFilesPausedDuration, setSoundFilesPausedDuration] = useState([]);

  useEffect(() => {
    // Cleanup function
    return () => {
      sources.forEach((source) => {
        if (source.audio) {
          source.audio.pause();
          source.audio.currentTime = 0;
        }
      });
    };
  }, [JSON.stringify(audios), sources]);

  useEffect(() => {
    setSources(
      audios.map((audio) => {
        return {
          url: audio.url,
          audio: new Audio(audio.url),
          id: audio.id,
        };
      })
    );
    setSoundFiles(
      audios.map((audio) => {
        return {
          url: audio.url,
          playing: false,
          id: audio.id,
        };
      })
    );
  }, [JSON.stringify(audios)]);

  var soundsPausedTime = [];

  const togglePlayAndPause = (targetIndex, sound, indexType = null) => () => {
    setToggledSound({ ...sound });
    const newPlayers = JSON.parse(JSON.stringify(soundFiles));
    const currentIndex = soundFiles.findIndex((p) => p.playing === true);
    if (sound.id !== toggledSound.id) {
      soundsPausedTime = [];
      setSoundFilesPausedDuration([]);
    }
    if (currentIndex !== -1 && currentIndex !== targetIndex) {
      newPlayers[currentIndex].playing = false;
      newPlayers[targetIndex].playing = true;
      stopAudio(sources[currentIndex], currentIndex);
    } else if (currentIndex !== -1) {
      newPlayers[targetIndex].playing = false;
    } else {
      if (indexType !== null) {
        stopAudio(sources[targetIndex], targetIndex);
      } else {
        newPlayers[targetIndex].playing = true;
      }
    }
    setSoundFiles(newPlayers);
  };

  useEffect(() => {
    soundsPausedTime = [];
    sources.forEach((source, i) => {
      if (soundFiles[i]) {
        if (source.id === toggledSound.id) {
          if (source.audio.currentTime !== soundFiles[i].duration) {
            soundsPausedTime.push({
              id: source.id,
              currentDuration: source.audio.currentTime,
            });
          }
        } else {
          source.audio.currentTime = 0;
        }
        setSoundFilesPausedDuration([...soundsPausedTime]);
        soundFiles[i].playing ? playSound(source.audio) : pauseAudio(source, i);
      }
    });
  }, [sources, soundFiles, JSON.stringify(audios)]);

  const playSound = (source) => {
    const playPromise = source.play();
    if (playPromise !== undefined) {
      playPromise.then((_) => {}).catch((error) => {});
    }
  };

  const pauseAudio = (source, index) => {
    source.audio.pause();
  };

  const handleStopAudio = (soundId) => {
    const findSound = sources.find((sound) => sound.id === soundId);
    const findSoundIndex = sources.findIndex((sound) => sound.id === soundId);
    togglePlayAndPause(findSoundIndex, findSound, findSoundIndex)();
    stopAudio(findSound, findSoundIndex);
    soundsPausedTime = [];
    setSoundFilesPausedDuration([]);
  };

  const stopAudio = (source, index) => {
    setSoundFilesPausedDuration([]);
    sources[index].audio.currentTime = 0;
  };

  useEffect(() => {
    sources.forEach((source, i) => {
      source.audio.addEventListener(
        "loadedmetadata",
        function() {
          const duration = source.audio.duration;
          const newPlayers = [...soundFiles];
          if (newPlayers[i]) newPlayers[i].duration = duration;
          setSoundFiles(newPlayers);
        },
        false
      );
    });
  }, [sources, JSON.stringify(audios)]);

  useEffect(() => {
    sources.forEach((source, i) => {
      source.audio.addEventListener(
        "ended",
        () => {
          const newPlayers = [...soundFiles];
          newPlayers[i].playing = false;
          setSoundFiles(newPlayers);
          stopAudio(source, i);
        },
        false
      );
    });
    return () => {
      soundsPausedTime = [];
      sources.forEach((source, i) => {
        stopAudio(source, i);
        source.audio.removeEventListener(
          "ended",
          () => {
            const newPlayers = [...soundFiles];
            newPlayers[i].playing = false;
            setSoundFiles(newPlayers);
          },
          false
        );
      });
    };
  }, [JSON.stringify(audios), sources]);

  return [
    soundFiles,
    togglePlayAndPause,
    soundFilesPausedDuration,
    handleStopAudio,
  ];
};
